import { render, staticRenderFns } from "./tabTradeDetail.vue?vue&type=template&id=e26e9a90&"
import script from "./tabTradeDetail.vue?vue&type=script&lang=js&"
export * from "./tabTradeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e26e9a90')) {
      api.createRecord('e26e9a90', component.options)
    } else {
      api.reload('e26e9a90', component.options)
    }
    module.hot.accept("./tabTradeDetail.vue?vue&type=template&id=e26e9a90&", function () {
      api.rerender('e26e9a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/tabs/tabTradeDetail.vue"
export default component.exports